import { render, staticRenderFns } from "./StepsCounter.vue?vue&type=template&id=b00fd7ee"
import script from "./StepsCounter.vue?vue&type=script&lang=js"
export * from "./StepsCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports